@if (style) {
	@if (style.status.id == styleStatus.Shooting) {
		<div class="flex center padding bg-orange">
			<i class="fa fa-circle-info margin-right-smallest"></i>
			Shooting in progress for this style. Data editing is not available.
		</div>
	}

	<div class="bg-lightest-blue padding-large">
		<div class="flex center">
			<h4>Style Details</h4>
		</div>

		<div class="flex center margin-top">
			<div class="flex column">
				<b>Style code</b>
				<div class="margin-top-smallest border bg-white padding-small">
					{{ style?.code || '-' }}
				</div>
			</div>

			<div class="flex column margin-left">
				<b>Style Name</b>
				<div class="margin-top-smallest border bg-white padding-small">
					{{ style?.name || '-' }}
				</div>
			</div>

			<div class="flex column margin-left">
				<b>Style Description</b>
				<div class="margin-top-smallest border bg-white padding-small">
					{{ style?.styleDescription?.name || '-' }}
				</div>
			</div>

			<div class="flex column margin-left">
				<b>Style Group</b>
				<div class="margin-top-smallest border bg-white padding-small">
					{{ style?.styleGroup?.name || '-' }}
				</div>
			</div>

			<div class="flex column margin-left">
				<b>Brand</b>
				<div class="margin-top-smallest border bg-white padding-small">
					{{ style?.brand?.name || '-' }}
				</div>
			</div>

			<div class="flex column margin-left">
				<b>Collection</b>
				<div class="margin-top-smallest border bg-white padding-small">
					{{ style?.collection?.name || '-' }}
				</div>
			</div>

			<div class="flex column margin-left">
				<b>Category</b>
				<div class="margin-top-smallest border bg-white padding-small">
					{{ style?.category?.name || '-' }}
				</div>
			</div>

			<div class="flex column margin-left">
				<b>Status</b>

				@if (style?.status?.id == styleStatus.MissingImages) {
					<div class="margin-top-smallest border padding-small radius bg-orange">Missing media</div>
				}
				@if (style?.status?.id == styleStatus.Shooting) {
					<div class="margin-top-smallest border padding-small radius bg-primary white">Shooting in progress</div>
				}
				@if (style?.status?.id == styleStatus.Confirmed) {
					<div class="margin-top-smallest border padding-small radius bg-green white">Confirmed images</div>
				}
			</div>
		</div>

		<!-- <div class="flex center m-full-width m-margin-top">
			<button class="m-flex-1">
				<i class="fa fa-check"></i>
				Confirm style
			</button>
		</div> -->
	</div>

	<div class="padding-large m-padding">
		<div class="page-layout">
			<div class="flex end between">
				<div class="flex center desktop-only">
					<!-- <span class="primary hover m-flex-1 margin-right" (click)="exportExcel()">
						<i class="fa fa-file-excel"></i>
						Download Excel
					</span> -->

					<span class="primary hover m-flex-1 margin-right {{ style.status.id == styleStatus.Shooting ? 'disabled' : '' }}" (click)="prepareUploadMultipleWithOrchestrator()">
						<i class="fa fa-upload"></i>
						Multiple Upload
					</span>
					@if (thereAreImages()) {
						<span class="primary hover m-flex-1 margin-right-small" (click)="downloadAllShots()">
							<i class="fa fa-download"></i>
							Download Images as Zip
						</span>

						<span class="red hover m-flex-1 margin-right-small {{ style.status.id == styleStatus.Shooting ? 'disabled' : '' }}" (click)="removeAllShots()">
							<i class="fa fa-eraser"></i>
							Remove all images
						</span>
					}
				</div>

				<div class="flex center">
					<button class="bg-green margin-left-small m-flex-1 disabled">
						<i class="fa fa-earth-europe"></i>
						Confirm & publish
					</button>
				</div>
			</div>

			@for (colorShots of styleColorShots.items; track colorShots; let i = $index) {
				<div class="flex column margin-top border radius">
					<div class="flex center between bg-light-grey padding-small radius radius-bottom-none">
						<div class="flex center">
							<b>{{ colorShots.color.name }}</b>

							@if (colorShots.color.default) {
								<div class="flex center orange desktop-only margin-left">
									<i class="fa-solid fa-star margin-right-smallest"></i>
									<b>Default color</b>
								</div>
							} @else {
								<div class="flex center grey hover desktop-only margin-left" (click)="setDefaultColor(colorShots.color.id)">
									<i class="fa-regular fa-star margin-right-smallest"></i>
									Set as default
								</div>
							}
						</div>

						<div class="flex center">
							@if (getNotUploadedShots(colorShots).length) {
								@if (getUploadedShots(colorShots).length == 0) {
									<span class="orange bold padding-smallest radius margin-right-small">All images missing</span>
								} @else {
									<span class="green bold padding-smallest margin-right-small">{{ getUploadedShots(colorShots)?.length || 0 }} images uploaded</span>
									<span class="orange bold padding-smallest margin-right-small">{{ getNotUploadedShots(colorShots)?.length || 0 }} images missing</span>
								}
							} @else {
								<span class="green bold padding-smallest margin-right-small">All shots uploaded</span>
							}

							<i class="fa-solid {{ colorShots.opened ? 'fa-chevron-up' : 'fa-chevron-down' }} hover" (click)="toggleColorShots(colorShots)"></i>
						</div>
					</div>

					@if (colorShots.opened) {
						<div class="padding">
							<div class="between flex center m-column m-start">
								<div class="flex center">
									<b>Available shots:</b>
								</div>

								<div class="flex center m-full-width m-margin-top-small">
									<div class="flex center primary hover desktop-only  {{ getShotsWithImages(colorShots).length ? '' : 'disabled' }} " (click)="viewGallery(getShotsWithImages(colorShots))">
										<i class="fa-solid fa-expand margin-right-small"></i>
										View as gallery
									</div>

									<!-- <div class="flex center primary hover margin-left desktop-only {{ getShotsWithImages(colorShots).length ? '' : 'disabled' }}" (click)="downloadShots(getIds(getShotsWithImages(colorShots)))">
										<i class="fa-solid fa-download margin-right-small"></i>
										Download images
									</div> -->
								</div>
							</div>

							<div class="shot-grid margin-top">
								@for (shot of colorShots.shots; track shot; let f = $index) {
									<div class="padding-small flex column border border-grey radius between {{ shot.shotApprovalStatus == shotApprovalStatus.Approved ? 'bg-light-green border-green' : shot.shotApprovalStatus == shotApprovalStatus.Rejected ? 'bg-light-red border-red' : 'bg-white' }}">
										<div class="flex center">
											<div class="flex-0 margin-right-small">
												@if (style.status.id == styleStatus.Shooting && shot.shotApprovalStatus != shotApprovalStatus.Approved) {
													<div class="placeholder flex center justify-center"><i class="grey fa fa-clock fa-lg"></i></div>
												} @else {
													@if (shot.imgPath) {
														<div class="placeholder shot-image-wrapper">
															@if (isShotImageLoading(shot) && !isVideo(shot)) {
																<div class="shot-image-loader flex center justify-center">
																	<i class="fa-solid fa-spinner fa-spin"></i>
																</div>
															}

															@if (isVideo(shot)) {
																<img class="shot-image hover" (click)="viewGallery(getShotsWithImages(colorShots), shot.id)"/>
																<i class="fa-solid fa-circle-play video-play-icon"></i>
															} @else {
																<img class="shot-image hover" (click)="viewGallery(getShotsWithImages(colorShots), shot.id)" [class.shot-image-hidden]="isShotImageLoading(shot)" [src]="shot.imgPath" alt="Shot preview" (load)="onShotImageLoad(shot)" (error)="onShotImageError(shot)" />
															}
														</div>
													} @else {
														<div class="placeholder flex center justify-center"><i class="grey fa fa-image"></i></div>
													}
												}
											</div>
											<div class="flex-1 flex column">
												<div class="flex center between">
													<b>{{ shot.shotType.name }}</b>

													@if (shot.mandatory) {
														<small class="primary flex center padding-smallest">
															<i class="fa-solid fa-lock margin-right-smallest"></i>
															Mandatory
														</small>
													}
												</div>

												<div class="flex column small">
													<div class="flex between">
														<div class="flex column">
															<div>Use: {{ shot.codifiedUse.name }}</div>
															<div>{{ shot.aspectRatio.id == 1 ? 'Square' : '-' }} {{ shot.aspectRatio.label }}, {{ shot.mediaFormat.name }}</div>

															<!-- <div class="flex center grey">
																<span class="unicode margin-top-smallest">{{ shot.estimatedFileName }}</span>
																<i class="fa-regular fa-copy margin-left-smallest hover" (click)="copyToClipboard(shot.estimatedFileName)"></i>
															</div> -->
														</div>
													</div>
												</div>
											</div>
										</div>

										<div class="flex column end margin-top">
											<div class="flex center">
												<!-- @if (shot.status.id == shotApprovalStatus.Approved) {
													<div class="flex center red hover disabled">
														<i class="fa fa-undo margin-right-smallest"></i>
														Reshoot
													</div>
												} -->

												<div class="flex center margin-left-small {{ style.status.id == styleStatus.Shooting ? 'disabled' : '' }}">
													<input type="file" [accept]="acceptedExtensions.join(',')" #fileInput (change)="onFilesSelected($event, shot, colorShots.color)" style="display: none" />

													<button (click)="fileInput.click()" class="mini">
														<i class="fa-solid fa-upload margin-right-smallest"></i>
														Upload
													</button>
												</div>
											</div>
										</div>
									</div>
								} @empty {
									<div class="bg-light-grey padding-small flex column justify-center center fix-height grey">No shots for this color</div>
								}
							</div>
						</div>
					}
				</div>
			}

			<bt-paginator [pageNumber]="styleColorShots.currentPage" [pageSize]="styleColorShots.size" [totalNumber]="styleColorShots.totalCount" (clickPage)="pageEvent($event)"></bt-paginator>
		</div>
	</div>
}

@if (loading) {
	<bt-loader></bt-loader>
}
